import React, { useContext, useEffect, useState } from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import productContext from '../../../Product/context/product/productContext'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { handleRedirectInternal } from '../../../Product/common/components'
import { useHistory } from 'react-router-dom'
import CartContext from '../../../Product/context/cart/cartContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import AuthContext from '../../../Product/context/auth/authContext'

export default function rushBins(props) {
    const ProductContext = useContext(productContext)
    const cartContext = useContext(CartContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { addToCart, buyer_cartitems, removeFromCart } = cartContext
    const { user } = authContext
    const { setAlert } = alertContext
    const { productLocalState } = ProductContext
    const [cartData, SetCartData] = useState([])
    const history = useHistory()

    // useEffect(() => {
    //     const cart = localStorage.getItem('cartData')
    //     if (cart) {
    //         const savedCart = JSON.parse(cart)
    //         if (savedCart.length > 0) {
    //             SetCartData(savedCart)
    //         }
    //     }
    // }, [])
    useEffect(() => {
        SetCartData(buyer_cartitems.results)
    }, [buyer_cartitems.results])
    const handleCart = (id) => {
        if (!user) {
            return handleRedirectInternal(history, 'login')
        }
        if (!user?.card_paymentid) {
            setAlert('Add a card to buy!', 'error')
            return handleRedirectInternal(history, 'dashboard/cards')
        }
        if (cartData.some((item) => item.product_id == id)) {
            removeFromCart({ id })
        } else
            addToCart({
                id: id,
                qty: 1,
            })
    }

    return (
        <>
            <SEOTAG page={`Rush Bins | Columbus, OH`} />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    <h2>Rush Bins</h2>

                    {/* <meta
                        name="description"
                        content="Our bin store offers deeply discounted items from major retailers. Products are placed in bins and the price you pay depends on the day you shop—higher on restock day, and dropping daily after that. It’s a fun, first-come-first-served treasure hunt!"
                    /> */}

                    <div className="rushBinsBx">
                        <section className="locations">
                            <div className="location-item">
                                <div className="map">
                                    <iframe
                                        allowFullScreen=""
                                        height="200"
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d763.3960855282165!2d-82.96443800000002!3d40.062376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388bc7e5a608f1%3A0x989c19f27cf7c1a!2sRetail%20Rush!5e0!3m2!1sen!2sus!4v1753705578924!5m2!1sen!2sus"
                                        style={{ border: 0 }}
                                        width="100%"
                                    ></iframe>
                                </div>

                                <div className="location-info">
                                    <h3>4645 Morse Centre Road, Columbus, OH 43229</h3>

                                    <p>Hours: Tue&ndash;Fri: 1pm&ndash;7pm, Sat: 12pm&ndash;6pm</p>
                                    <a
                                        className="location-link"
                                        href="https://maps.app.goo.gl/Pb11St6ED9vjovfm7"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        View Location Page
                                    </a>
                                </div>
                            </div>
                        </section>

                        <section className="sectionContainer">
                            <h4 className="binsTit">
                                Rush Bins &ndash; Dive Into the Deal Zone!&nbsp;
                            </h4>

                            <div className="binsDescBox">
                                <p className="pTag">
                                    Welcome to&nbsp;Rush Bins&nbsp;&ndash; your new favorite
                                    treasure hunt at Retail Rush! Every visit is an adventure where
                                    you never know what gem you&rsquo;ll uncover. With prices
                                    dropping daily &mdash; from $7 Fridays to $1 Thursdays (plus the
                                    legendary $10 Fill-a-Bag deal!) &mdash; every day is a chance to
                                    score big for less. Just walk in, discover incredible finds, and
                                    walk out with unbeatable deals &mdash; it&rsquo;s another
                                    exciting way to shop at Retail Rush!
                                </p>
                            </div>
                        </section>

                        <section className="sectionContainer">
                            <h4 className="binsTit">How It Works&nbsp;</h4>

                            <div className="binsDescBox">
                                <p className="pTag">
                                    Our bin store offers deeply discounted items from major
                                    retailers. Products are placed in bins and the price you pay
                                    depends on the day you shop&mdash;higher on restock day, and
                                    dropping daily after that. It&rsquo;s a fun,
                                    first-come-first-served treasure hunt!
                                </p>

                                <div className="innerTableDesign">
                                    <h4>Business Hours</h4>

                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Monday</td>
                                                <td>Closed</td>
                                            </tr>
                                            <tr>
                                                <td>Tuesday</td>
                                                <td>1pm&ndash;7pm</td>
                                            </tr>
                                            <tr>
                                                <td>Wednesday</td>
                                                <td>1pm&ndash;7pm</td>
                                            </tr>
                                            <tr>
                                                <td>Thursday</td>
                                                <td>1pm&ndash;7pm</td>
                                            </tr>
                                            <tr>
                                                <td>Friday</td>
                                                <td>1pm&ndash;7pm</td>
                                            </tr>
                                            <tr>
                                                <td>Saturday</td>
                                                <td>12pm&ndash;6pm</td>
                                            </tr>
                                            <tr>
                                                <td>Sunday</td>
                                                <td>Closed</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section>

                        <section className="sectionContainer">
                            <h4 className="binsTit">Rush Pass **Coming Soon**</h4>

                            <div className="binsDescBox">
                                <p className="pTag">
                                    The Rush Pass lets you beat the crowd! It gives you early access
                                    to the Bin Store&mdash;one hour before regular opening
                                    time&mdash;on the day you choose. You can grab a single-day pass
                                    for just $5, or save more with a 5-day pass for $20. Rush
                                    Passes&nbsp;CANNOT&nbsp;be used on Saturdays.
                                </p>

                                <div
                                    aria-label="Rush Pass options"
                                    className="pass-container"
                                    role="list"
                                >
                                    <div
                                        aria-label="Early Access Single-Day Pass, $5"
                                        className="pass-card"
                                        role="listitem"
                                        tabIndex="0"
                                    >
                                        <h3>Early Access</h3>

                                        <p className="pass-price">Single-Day Pass</p>

                                        <p className="pass-price">$5.00</p>
                                        <PrimaryButton
                                            btnSize={'small'}
                                            onClick={() =>
                                                handleCart(
                                                    global.storeConfigration?.single_day_pass_id
                                                        ?.value,
                                                )
                                            }
                                            // disabled={data.buynow == 0}
                                            label={
                                                cartData.some(
                                                    (item) =>
                                                        item.product_id ==
                                                        global.storeConfigration?.single_day_pass_id
                                                            ?.value,
                                                ) === true
                                                    ? 'Remove From Cart'
                                                    : 'Add to Cart'
                                            }
                                        />
                                    </div>

                                    <div
                                        aria-label="Early Access 5-Day Pass, $20"
                                        className="pass-card"
                                        role="listitem"
                                        tabIndex="0"
                                    >
                                        <h3>Early Access</h3>

                                        <p className="pass-price">5-Day Pass</p>

                                        <p className="pass-price">$20.00</p>
                                        <PrimaryButton
                                            btnSize={'small'}
                                            onClick={() =>
                                                handleCart(
                                                    global.storeConfigration?.five_day_pass_id
                                                        ?.value,
                                                )
                                            }
                                            // disabled={data.buynow == 0}
                                            label={
                                                cartData.some(
                                                    (item) =>
                                                        item.product_id ==
                                                        global.storeConfigration?.five_day_pass_id
                                                            ?.value,
                                                ) === true
                                                    ? 'Remove From Cart'
                                                    : 'Add to Cart'
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="sectionContainer">
                            <h4 className="binsTit">Bag Day</h4>

                            <div className="binsDescBox">
                                <p className="pTag">
                                    Bag Day is your chance to save big! Every Thursday, you can fill
                                    a Retail Rush branded bag for just $10&mdash;or choose to pay $1
                                    per item. Bags are available for purchase on-site, and if you
                                    bring yours back each week, you save even more. Just remember:
                                    only our branded bags are allowed on Bag Day.
                                </p>

                                <table
                                    aria-label="Bag Day pricing table"
                                    className="bag-day-table table-responsive"
                                >
                                    <thead>
                                        <tr>
                                            <th>Tuesday</th>
                                            <th>Wednesday</th>
                                            <th>Thursday</th>
                                            <th>Friday</th>
                                            <th>Saturday</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>$3.00</td>
                                            <td>$2.00</td>
                                            <td>
                                                $1.00
                                                <div className="fill-bag-cell">
                                                    Fill a bag for $10
                                                </div>
                                                <div
                                                    className="fill-bag-note"
                                                    style={{
                                                        fontSize: '12px',
                                                        width: '100%',
                                                        margin: 'auto',
                                                        marginTop: '10px',
                                                        fontWeight: 300,
                                                        textAlign: 'center',
                                                        maxWidth: '150px',
                                                    }}
                                                >
                                                    Refillable Retail Rush bag is $10 on first
                                                    purchase. Reuse your bag to save more!&middot;
                                                </div>
                                            </td>
                                            <td>$7.00</td>
                                            <td>$5.00</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <p className="helperinfo">
                                    We restock our bins every week after closing on
                                    Thursday&mdash;so you&rsquo;ll find a fresh selection waiting
                                    for you starting Friday afternoon!
                                </p>
                            </div>
                        </section>

                        <section className="sectionContainer">
                            <div className="binsDescBox rvBrd">
                                <p className="pTag">
                                    We accept all major credit and debit cards&mdash;including Visa,
                                    Mastercard, American Express, and Discover. You can also use
                                    prepaid cards and digital wallet options if supported by your
                                    card provider.
                                </p>

                                <div className="hrSmLine">&nbsp;</div>

                                <p className="helperinfo">
                                    All sales are final on Bin Store items, so we unfortunately
                                    can&rsquo;t accept returns. We always recommend checking items
                                    carefully before purchase!
                                </p>
                            </div>
                        </section>
                    </div>
                    {/* <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.careers,
                        }}
                    ></span> */}
                </div>
                {/* {cartData ? (
                    <div
                        className={`floatingPassCart ${cartData != 0 ? 'd-block' : 'd-none'}`}
                        onClick={() => handleRedirectInternal(history, 'rushPass')}
                    >
                        <div className="passBox">
                            <h6>Rush Pass</h6>
                            <div className="passBoxFlex">
                                <span className="material-icons-outlined">shopping_cart</span>
                                <i className="count pl-1">
                                    &#40;{cartData && cartData.length}&#41;
                                </i>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )} */}
            </Layout>
        </>
    )
}
